import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { getLocationHash } from 'selectors/getPageLocation'

const withScrollToHashOnChange = lifecycle({
  componentDidMount() {
    const { hash } = this.props
    const scrollToElement = document.getElementById((hash || '').slice(1))
    if (scrollToElement) {
      scrollToElement.scrollIntoView(true)
    }
  }
})

const mapStateToProps = state => ({
  hash: getLocationHash(state)
})

export default compose(
  connect(mapStateToProps),
  withScrollToHashOnChange
)
